import { MediaFileService } from '../../data/media-file.service'
import type { MediaFolder } from '../models/media-folder'

const ensurePath = async (path: string): Promise<MediaFolder | undefined> => {
  let currentFolder: MediaFolder | undefined = undefined
  const pathParts = path.split('/')
  for (const part of pathParts) {
    if (part === '') continue
    const parentFolder = currentFolder?.parentFolderId
    currentFolder = await MediaFileService.createFolder(part, parentFolder)
  }
  return currentFolder
}

export default ensurePath
